import React, { ReactNode, JSX } from "react";
import cn from "classnames";
import styles from "./TextDetail.module.scss";

export type TextDetailProps = {
  id?: string;
  children: ReactNode | string;
  size: "m";
  weight?: "bold" | "regular";
  variant: "p" | "span" | "strong" | "em" | "b";
  className?: string;
};

const TextDetail = ({
  id,
  children,
  size,
  weight,
  className,
  variant,
}: TextDetailProps): JSX.Element => {
  const getProps = () => ({
    ...(id && { id: `text-detail-${id}` }),
    className: cn(
      styles.text,
      {
        [styles.bold]: weight === "bold",
        [styles.regular]: weight === "regular",
        [styles.m]: size === "m",
      },
      className
    ),
    children,
  });

  const variants = {
    p: <p {...getProps()} />,
    span: <span {...getProps()} />,
    strong: <strong {...getProps()} />,
    em: <em {...getProps()} />,
    b: <b {...getProps()} />,
  };

  return variants[variant];
};

TextDetail.defaultProps = {
  variant: "p",
  size: "m",
  weight: "regular",
};

export default TextDetail;
